<div class="json-diff-container">
  <input
    id="showunchanged"
    type="checkbox"
    (click)="showUnchange()"
    [(ngModel)]="showunchanged"
  /><label for="showunchanged"> Show unchanged values </label>

  <div id="diff-container" class="scrollable-container"></div>
</div>
